import React from "react";
import {Col, Row} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces, clientModel } from "@reco-w/client-models";
import { BackTopBox } from "@reco-w/about-e";

const clientData = [
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "综合开发区",
        "CatalogCode": "zonghkfq",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 1,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:27.77",
        "ID": 2341234437783749,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399471006646336,
                "Title": "漕河泾开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:40:17.367",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:20.49",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399471308636216,
                "Title": "临港新片区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:40:35.61",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:24.557",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399472080388169,
                "Title": "上海金桥经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:41:21.997",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:25.7",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399472818585798,
                "Title": "上海自贸区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:42:05.347",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:26.467",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399473489674494,
                "Title": "外高桥保税区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:42:45.847",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:27.313",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399473741332593,
                "Title": "上海世博开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:00.003",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:43:28.047",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474009768172,
                "Title": "宜秀经济开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:16.76",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474546639101,
                "Title": "南京经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:43:48.753",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399474764742761,
                "Title": "武汉经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:01.203",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475066732650,
                "Title": "北京未来科学城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:19.737",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475234504814,
                "Title": "定州经开区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:29.117",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:06.45",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475469385851,
                "Title": "临港海洋高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:43.303",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:12.12",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475586826345,
                "Title": "合肥国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:50.377",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:19.567",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475737821330,
                "Title": "贵阳国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:44:59.183",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:21.91",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475855261764,
                "Title": "海口国家高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:06.97",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:26.77",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399475989479664,
                "Title": "安庆筑梦新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:14.723",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:31.93",
                "Sequence": 160,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476140474514,
                "Title": "马鞍山郑蒲港新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:23.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:34.02",
                "Sequence": 170,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476257915073,
                "Title": "三门峡高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:30.79",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:39.357",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476408910017,
                "Title": "贵阳综合保税区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:39.427",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:47:32.127",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476694122690,
                "Title": "大庆高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:45:56.763",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:41.917",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476845117640,
                "Title": "上海迪士尼乐园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:05.797",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:43.783",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399476979335339,
                "Title": "上海长兴岛",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:13.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:45.757",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477079998542,
                "Title": "盘锦高新区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:19.843",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:49.097",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477264547986,
                "Title": "中宁工业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:30.28",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:51.427",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477381988549,
                "Title": "广州高新技术产业开发区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:37.943",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:53.507",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477516206144,
                "Title": "广州民营科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:45.06",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:56.277",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399477667201264,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:46:54.89",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:48:59.93",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "综合开发区",
                "CatalogueID": 2341234437783749,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "高新技术产业园",
        "CatalogCode": "gaoxjscyy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 2,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:46.14",
        "ID": 2341234756550733,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399480385110065,
                "Title": "张江高科",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:49:36.447",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:45.543",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399480519327765,
                "Title": "中关村昌平园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:49:44.19",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:46.597",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481190416405,
                "Title": "临港松江科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:24.317",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:48.117",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481307857030,
                "Title": "上海临空经济园区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:31.85",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:49.217",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481425297598,
                "Title": "临港海立方科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:38.753",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:55.13",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481525960838,
                "Title": "上海银行卡产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:44.287",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:56.717",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481643401345,
                "Title": "上海徐汇软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:51.94",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:58.257",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481760841746,
                "Title": "广州荔湾海龙科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:50:58.27",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:53:59.31",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481861505115,
                "Title": "上海临港软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:04.927",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:00.737",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399481962168334,
                "Title": "南京智能制造产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:10.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:02.26",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482213826614,
                "Title": "嘉兴科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:25.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:03.707",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482364821680,
                "Title": "牡丹智慧园（牡丹集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:34.74",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:05.927",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482482262181,
                "Title": "北京新元科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:41.72",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:06.917",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482599702584,
                "Title": "北京房山互联网金融产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:48.287",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:08.923",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399482683588643,
                "Title": "北京光机电一体化产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:51:53.73",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:10.43",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483069464590,
                "Title": "张江集电港",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:16.11",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:19.553",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483153350748,
                "Title": "上海周浦智慧产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:21.783",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:21.15",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483304345682,
                "Title": "中国传感网国际创新园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:30.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:22.147",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483455340580,
                "Title": "国信安基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:39.26",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:23.653",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483589558364,
                "Title": "上海唐镇电子商务创新港",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:47.187",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:24.76",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483690221604,
                "Title": "无锡（国家）软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:53.383",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:25.897",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483790884882,
                "Title": "中新仁恒海门长江生态科技城",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:52:59.72",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:27.28",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399483908325594,
                "Title": "中国出版蓝桥创意产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:06.06",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:28.747",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484008988743,
                "Title": "移动智地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:12.267",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:29.997",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484109652139,
                "Title": "江苏虚拟软件园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:18.953",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:32.13",
                "Sequence": 270,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399484277424311,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:53:28.553",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "高新技术产业园",
                "CatalogueID": 2341234756550733,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "大学科技园",
        "CatalogCode": "daxkjy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 3,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:27:54.073",
        "ID": 2341234890768559,
        "chileList": [
            {
                "ProjectContent": "",
                "ID": 2344373572337831,
                "Title": "北京大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:25:54.693",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:57.923",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344373874327619,
                "Title": "清华大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:12.997",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:54:58.893",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374075654311,
                "Title": "浙江大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:24.63",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:00.433",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374260203773,
                "Title": "同济大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:35.237",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:02.17",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344374444752928,
                "Title": "上海交通大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:26:46.79",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:55:04.26",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486072586331,
                "Title": "上海理工大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:15.33",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:25.49",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486324244529,
                "Title": "西安交大国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:30.243",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:26.527",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486391353565,
                "Title": "北京农学院科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:34.227",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:27.577",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486508793920,
                "Title": "长兴国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:41.29",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:28.703",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486609457373,
                "Title": "洛阳国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:47.43",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:30.22",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486726897713,
                "Title": "上海体育学院科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:55:54.323",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:31.457",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486827561051,
                "Title": "保定国家大学科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:56:00.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:34.367",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399486995333169,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:56:10.293",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "大学科技园",
                "CatalogueID": 2341234890768559,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "生物医药产业园",
        "CatalogCode": "shengwyycyy",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 4,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:07.147",
        "ID": 2341235108872389,
        "chileList": [
            {
                "ProjectContent": "",
                "ID": 2344374931292234,
                "Title": "张江生物医药基地（张江药谷）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:15.437",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:54:19.5",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375132618869,
                "Title": "北京中关村生命科学园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:27.123",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:55:31.85",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424128900431897,
                "Title": "上海国际医学园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:55:42.243",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:55:47.24",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375333945587,
                "Title": "北京大兴生物医药产业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:39.083",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-06-30T14:55:08.49",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424129470857389,
                "Title": "上海张江药谷公共服务平台",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:16.653",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:23.623",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424129605074981,
                "Title": "上海市生物医药促进中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:24.447",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:32.907",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344375518494914,
                "Title": "江苏无锡惠山生命科技产业园区",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:50.66",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:58:12.563",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2424130091614381,
                "Title": "上海金山区生物医药产业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-30T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-30T15:56:53.733",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:57:37.63",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2344374696411212,
                "Title": "上海维亚生物国际孵化基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:27:01.577",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-30T15:54:30.96",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            },
            {
                "ProjectContent": "",
                "ID": 2344375921147934,
                "Title": "……",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-06-05T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-06-05T15:28:14.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T15:56:57.387",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": "<p>&nbsp;</p>"
                },
                "ContentTEXT": " ",
                "ImgUrls": [],
                "CatalogueName": "生物医药产业园",
                "CatalogueID": 2341235108872389,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "孵化众创",
        "CatalogCode": "fuhq/zckj",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 5,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:19.76",
        "ID": 2341235310198981,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399488773718152,
                "Title": "杨浦科创",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:57:56.95",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:26.517",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399488874381403,
                "Title": "中关村e谷",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:02.96",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:27.677",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489008599176,
                "Title": "上海交大慧谷科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:10.34",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:29.197",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489126039708,
                "Title": "康佳之星",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:17.023",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:30.133",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489226703095,
                "Title": "阿里云创新中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:23.983",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:31.24",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489344143480,
                "Title": "麦腾众创",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:30.093",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:32.493",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489495138382,
                "Title": "漕河泾创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:39.787",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:33.527",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489813905464,
                "Title": "张江孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:58:58.027",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:38.407",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399489948123214,
                "Title": "上海虹口区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:06.147",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:39.74",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490132672576,
                "Title": "上海奉贤区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:17.203",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:40.857",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490233336029,
                "Title": "同济大学科技园创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:23.67",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:43.867",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490367553776,
                "Title": "同济大学科技园国康路创业基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:31.41",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:45.29",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490518548701,
                "Title": "同济嘉定科技创业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:40.81",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:49.86",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490635989112,
                "Title": "复旦大学科技园创业中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:47.517",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:51.717",
                "Sequence": 150,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490786984096,
                "Title": "上海交大金桥科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T15:59:56.93",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:54.53",
                "Sequence": 160,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399490904424484,
                "Title": "上海交大嘉兴科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:03.707",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:55.973",
                "Sequence": 170,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491021865129,
                "Title": "上海环保科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:10.073",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:57.517",
                "Sequence": 180,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491172860125,
                "Title": "上海慧谷白猫科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:19.16",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:02:59.33",
                "Sequence": 190,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491256746104,
                "Title": "上海上生慧谷生物科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:24.933",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:02.81",
                "Sequence": 200,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491357409495,
                "Title": "上海新慧谷科技产业园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:30.993",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:04.413",
                "Sequence": 210,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491458072745,
                "Title": "上海慧山科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:36.697",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:16.22",
                "Sequence": 220,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491575513198,
                "Title": "北航先进技术产业基地（佛山）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:43.63",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:17.767",
                "Sequence": 230,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491692953628,
                "Title": "上海市科创-闵行加速器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:50.423",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:19.363",
                "Sequence": 240,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491793616897,
                "Title": "上海集成电路创业孵化基地",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:00:56.657",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:20.53",
                "Sequence": 250,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399491894280361,
                "Title": "张江移动互联网孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:02.74",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:21.66",
                "Sequence": 260,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492028497998,
                "Title": "上海黄浦区科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:10.187",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:22.987",
                "Sequence": 270,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492162715758,
                "Title": "江苏武进科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:18.637",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:24.34",
                "Sequence": 280,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492313710827,
                "Title": "江苏常州湖塘科创园\t",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:27.313",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:26.593",
                "Sequence": 290,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492414374141,
                "Title": "创业谷•光华",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:33.737",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:28.5",
                "Sequence": 300,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492548591869,
                "Title": "清控科创-北京双创街",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:41.127",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:34.127",
                "Sequence": 310,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492666032297,
                "Title": "袍江科创中心",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:48.46",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:35.387",
                "Sequence": 320,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492783472809,
                "Title": "北京禾芫科技孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:01:55.823",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:36.48",
                "Sequence": 330,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399492900913180,
                "Title": "北京赛欧孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:02.363",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:37.677",
                "Sequence": 340,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399493018353900,
                "Title": "意谷时代科技孵化器",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:09.763",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:39.117",
                "Sequence": 350,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399493135794430,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:02:16.71",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:03:44.237",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "孵化众创",
                "CatalogueID": 2341235310198981,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "产业地产",
        "CatalogCode": "kaifjt/cydc",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 6,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:38.99",
        "ID": 2341235628966085,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399495836925959,
                "Title": "临港集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:04:57.027",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:49.407",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399495937589318,
                "Title": "招商蛇口",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:03.003",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:50.363",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496021475421,
                "Title": "启迪协信集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:08.953",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:52.037",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496122138631,
                "Title": "张江集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:14.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:52.867",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496222801990,
                "Title": "外高桥集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:20.707",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:53.83",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496340242651,
                "Title": "上汽集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:27.053",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:55.107",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496440905926,
                "Title": "中国文化产业发展集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:33.043",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:56.34",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496558346330,
                "Title": "上海静工（集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:40.553",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:57.847",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496642232410,
                "Title": "新加坡仁恒置地集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:45.857",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:01.527",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496726118649,
                "Title": "上海宝华企业集团",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:50.89",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:02.803",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496826781907,
                "Title": "华鑫置业（集团）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:05:56.773",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:07.517",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399496927444999,
                "Title": "华润置地（华东大区）",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:02.68",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:12.243",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497028108522,
                "Title": "保福科技园",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:08.48",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:13.763",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497145548927,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:15.177",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:09:18.097",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "产业地产",
                "CatalogueID": 2341235628966085,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    },
    {
        "AppID": 925078493593699,
        "BindTableName": "STDArticle",
        "CatalogName": "政府",
        "CatalogCode": "zhengf",
        "ParentID": 2341234286788805,
        "Layer": 2,
        "Path": ",0,2,2341234286788805,",
        "Sequence": 7,
        "IsValid": true,
        "IsDelete": false,
        "Inputer": "系统管理员",
        "InputerID": 1,
        "InputTime": "2020-06-03T11:28:46.963",
        "ID": 2341235763183813,
        "chileList": [
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497531424969,
                "Title": "北京天竺镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:38.823",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:17.313",
                "Sequence": 10,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497632088191,
                "Title": "上海市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:44.813",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:19.083",
                "Sequence": 20,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497749528646,
                "Title": "天津津南区政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:51.033",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:20.433",
                "Sequence": 30,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497833414754,
                "Title": "合肥市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:06:56.363",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:21.63",
                "Sequence": 40,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399497934078180,
                "Title": "杭州市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:02.517",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:22.743",
                "Sequence": 50,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498034741485,
                "Title": "晋中市政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:08.44",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:24.153",
                "Sequence": 60,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498118627398,
                "Title": "贵阳市委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:13.833",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:25.093",
                "Sequence": 70,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498219290852,
                "Title": "川沙新镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:19.083",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:26.453",
                "Sequence": 80,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498336731234,
                "Title": "北蔡镇政府",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:26.01",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:28.157",
                "Sequence": 90,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498420617444,
                "Title": "浦东新区区委组织部",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:31.597",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:32.07",
                "Sequence": 100,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498521280596,
                "Title": "浦东新区国家发改委",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:37.583",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:33.167",
                "Sequence": 110,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498621944027,
                "Title": "武汉市青山区科学技术局",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:43.493",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:36.063",
                "Sequence": 120,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498705830007,
                "Title": "浦东新区科经委",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:48.7",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:37.287",
                "Sequence": 130,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498806493385,
                "Title": "周家渡街道",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:07:54.417",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:41.357",
                "Sequence": 140,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            },
            {
                "Customers": "",
                "ProjectContent": "",
                "ID": 2399498907156587,
                "Title": "......",
                "Source": "IParkPush",
                "Views": 0,
                "IsValid": true,
                "ArchiveStatus": 1,
                "PublishTime": "2020-07-13T00:00:00",
                "Inputer": "演示用户",
                "InputerID": 1318173110436079,
                "InputTime": "2020-07-13T16:08:00.577",
                "Updater": "演示用户",
                "UpdaterID": 1318173110436079,
                "UpdateTime": "2020-07-13T16:08:44.107",
                "Sequence": 500,
                "Share": 0,
                "Content": {
                    "ContentHTML": ""
                },
                "ContentTEXT": "",
                "ImgUrls": [],
                "CatalogueName": "政府",
                "CatalogueID": 2341235763183813,
                "CommentNum": 0
            }
        ],
        "ImgUrl": "http://demo.bitech.cn/BitechWebsiteiPark/mobileapi/Assets/Images/nopic.jpg"
    }
]

export namespace Client {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, clientModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.client;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/client`);
        }
        componentDidMount() {
            this.dispatch("input", {
                clientIndex: "zonghkfq",
                choseList: clientData[0].chileList
            });
        }

        renderSystem() {
            const introduceData = [
                "assets/images/guanw/biaog-logo1.png",
                "assets/images/guanw/biaog-logo2.png",
                "assets/images/guanw/biaog-logo3.png",
                "assets/images/guanw/biaog-logo4.png",
                "assets/images/guanw/biaog-logo5.png",
                "assets/images/guanw/biaog-logo6.png",
                "assets/images/guanw/biaog-logo7.png",
                "assets/images/guanw/biaog-logo8.png",
                "assets/images/guanw/biaog-logo9.png",
                "assets/images/guanw/biaog-logo10.png",
                "assets/images/guanw/biaog-logo11.png",
                "assets/images/guanw/biaog-logo12.png",
                "assets/images/guanw/biaog-logo13.png",
                "assets/images/guanw/biaog-logo14.png",
                "assets/images/guanw/biaog-logo15.png",
                "assets/images/guanw/biaog-logo16.png",
                "assets/images/guanw/biaog-logo17.png",
                "assets/images/guanw/biaog-logo18.png",
                "assets/images/guanw/biaog-logo19.png",
                "assets/images/guanw/biaog-logo20.png",
                "assets/images/guanw/biaog-logo21.png",
                "assets/images/guanw/biaog-logo22.png",
                "assets/images/guanw/biaog-logo23.png",
                "assets/images/guanw/biaog-logo24.png",
                "assets/images/guanw/biaog-logo25.png",
                "assets/images/guanw/biaog-logo26.png",
                "assets/images/guanw/biaog-logo27.png",
                "assets/images/guanw/biaog-logo28.png",
                "assets/images/guanw/biaog-logo29.png",
                "assets/images/guanw/biaog-logo30.png"
            ]
            const {state} = this.props,
                introIndex = state!.introIndex;
            return (
                <div className="block-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>标杆客户</span>
                        </div>
                        <Row className="introduce-nav" gutter={{xs: 8, sm: 16, md: 20}}>
                            {introduceData.map((item, i) => {
                                return (
                                    <Col span={5} key={i}>
                                        <div
                                            className={introIndex === i ? "introduce-nav-item active" : "introduce-nav-item"}
                                            onClick={() => this.dispatch("input", {introIndex: i})}
                                        >
                                            <img src={item} />
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </div>
                </div>
            )
        }

        renderCompany() {
            const {state} = this.props,
                clientIndex = state!.clientIndex,
                choseList = state!.choseList;
            return (
                <div className="block-content">
                    <div className="container" style={{overflow:"visible"}}>
                        <div className="second-title">
                            <span>其他客户</span>
                        </div>
                        <div className="client-tabs">
                            {
                                clientData && clientData.map((item, i) => {
                                    return (
                                        <span
                                            key={i}
                                            className={clientIndex === item.CatalogCode ? "active" : ""}
                                            onClick={() => this.dispatch("input", {clientIndex: item.CatalogCode, choseList: item.chileList})}
                                        >
                                            {item.CatalogName}
                                        </span>
                                    )
                                })
                            }
                        </div>
                        <Row gutter={[20,20]} className="mt30 client-other">
                            {
                                choseList && choseList.map((item, i) => {
                                    return (
                                        <Col xs={12} sm={12} md={12} xl={8} key={i}>
                                            <div className="client-item">
                                                <span>{item.Title}</span>
                                                <i className="border1" />
                                                <i className="border2" />
                                                <i className="border3" />
                                                <i className="border4" />
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/hzal-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">合作客户</div>
                                <div className="banner-text-name2 mt25">
                                    以科技创新赋能园区产业发展
                                </div>
                            </div>}
                        />
                        {this.renderSystem()}
                        {this.renderCompany()}

                        {/*<div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>*/}
                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.client]);
}
